import { Alert, Box, Button, Card, PasswordInput, Stack, Text, Title } from '@mantine/core';
import { IconAlertTriangle } from '@tabler/icons-react';
import { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useSetupAdmin } from '../api/admin-users';
import { ApiError } from '../api/client';

export function SetupPage() {
  const navigate = useNavigate();
  const { token = '' } = useParams<{ token: string }>();
  const setup = useSetupAdmin();

  const [pw, setPw] = useState('');
  const [confirm, setConfirm] = useState('');
  const [error, setError] = useState<string | null>(null);

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setError(null);

    if (pw.length < 12) {
      setError('Password must be at least 12 characters.');
      return;
    }
    if (pw !== confirm) {
      setError('Passwords do not match.');
      return;
    }

    setup.mutate(
      { token, newPassword: pw },
      {
        onSuccess: () => navigate('/login'),
        onError: (err) => {
          if (err instanceof ApiError && err.status === 409) {
            setError(
              'This invitation link has expired or already been used. Ask the inviting admin to send a new one.',
            );
          } else if (err instanceof ApiError && err.status === 400) {
            setError('Password validation failed. Try a longer password.');
          } else {
            setError('Failed to set password. Please try again.');
          }
        },
      },
    );
  };

  return (
    <Stack align="center" justify="center" mih="100vh" p="lg">
      <Card shadow="md" padding="xl" w={480} withBorder>
        <Stack gap="lg">
          <div>
            <Title order={2}>Set your password</Title>
            <Text size="sm" c="dimmed">
              Choose a password of at least 12 characters.
            </Text>
          </div>
          <Box component="form" onSubmit={handleSubmit} noValidate>
            <Stack gap="md">
              {error && (
                <Alert color="red" icon={<IconAlertTriangle size={18} />}>
                  {error}
                </Alert>
              )}
              <PasswordInput
                id="setup-new-password"
                label="New password"
                required
                value={pw}
                onChange={(e) => setPw(e.currentTarget.value)}
                disabled={setup.isPending}
              />
              <PasswordInput
                id="setup-confirm-password"
                label="Confirm password"
                required
                value={confirm}
                onChange={(e) => setConfirm(e.currentTarget.value)}
                disabled={setup.isPending}
              />
              <Button type="submit" loading={setup.isPending} fullWidth>
                Set password
              </Button>
            </Stack>
          </Box>
        </Stack>
      </Card>
    </Stack>
  );
}
